export { default as customInsightSelectors } from './custom'